import i18n from "i18next";
import { initReactI18next } from "react-i18next";

let language = "en";

i18n.use(initReactI18next).init({
  fallbackLng: language,
  lng: language,
  resources: {
    en: {
      translations: require("./locales/en/translations.json"),
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
});

i18n.languages = ["en"];

export default i18n;
